<template>
  <div>
    <generic-container
      :title="$t('seasons')"
      icon="school"
      :configurable="true"
      v-bind:configure_modal="configure_modal"
      :header_buttons="header_buttons"
    >
      <div class="ui three cards">
        <div v-for="(season, index) in seasons" :key="index" class="card">
          <div class="content">
            <div class="ui dividing header">{{ season.name }}</div>
            <div class="description">
              <h4
                class="ui dividing head"
                v-if="
                  season.crs_assignation_sections &&
                    season.crs_assignation_sections.length
                "
              >
                {{ $t("courses") }}
              </h4>
              <div
                class="ui bulleted list"
                v-if="
                  season.crs_assignation_sections &&
                    season.crs_assignation_sections.length
                "
              >
                <a
                  class="link item"
                  v-for="(section, idx) in season.crs_assignation_sections"
                  :key="idx"
                  @click="check_section(section)"
                >
                  {{ section.crs_course.name }} [ {{ section.name }}
                  <span v-if="section.setup && section.setup.schedule"
                    >@ {{ section.setup.schedule }}</span
                  >
                  ]
                </a>
              </div>
              <div class="ui error message" v-else>
                <div class="content">
                  <div class="header">
                    {{ $t("no section course assigned") }}
                  </div>
                  <p>
                    {{
                      $t(
                        "you dont have any sections course assigned on this season",
                      )
                    }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </generic-container>
  </div>
</template>

<script>
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
import ConfigureModal from "./configuration_modal/Index.vue";
import { local_api, error_toast } from "@/utils";

// @ is an alias to /src
export default {
  name: "CourseAssignationIndex",
  components: {
    "generic-container": GenericContainer,
  },
  filters: filters,
  data() {
    return {
      seasons: [],
      configure_modal: ConfigureModal,
      selected_assignation: undefined,
      header_buttons: [
        {
          icon: "refresh",
          tooltip: this.$t("refresh"),
          click: this.refresh,
        },
      ],
    };
  },
  methods: {
    refresh() {
      let vm = this;
      local_api(vm, "post", "/course/scoring/do-get-season-list", {})
        .then((seasons) => {
          vm.seasons = seasons;
        })
        .catch((err) => {
          error_toast(err);
        });
    },
    check_section(assignation) {
      this.$router.push({
        name: "CourseScoringRevision",
        query: { i: assignation.uuid },
      });
    },
  },
  created() {},
  mounted() {
    this.refresh();
  },
  watch: {},
};
</script>
